module.exports = __webpack_public_path__ + "img/Vector_nav_data.96943b00.svg";